<template>
  <div>
    <p>
      Please enter the login code that was sent to you and click Validate login code. <span v-if="!(this.$store.state.guestLogin.loginUserDetails.isPaperOtpSent && this.$store.state.guestLogin.mfaType == 3) && this.$store.state.guestLogin.loginMfaRequest && this.$store.state.guestLogin.loginMfaRequest.otpEndDateTime">
      The login code is valid until {{ otpEndTime }}.</span> Do not share this login code with anyone.
      If you did not receive the login code you can click 'Resend login code' or click 'Previous' to go back and review your contact information. After reviewing the contact information you can
      click 'Next' to resend the login code or, if applicable, click 'Not my contact info'.
    </p>

    <div class="user-otp">
      <div class="input-otp">
        <label for="loginCode" class="otp-text app-required-indicator __after">Login code</label>
        <input type="text" name="OneTimePassword" v-model="otp" maxlength="12">
        <p v-if="errorMsg" class="error-msg">
          {{ errorMsg }}
        </p>
        <p class="sr-only" v-if="errorMsg">
          {{ errorMsg }}
        </p>
      </div>
    </div>

    <BaseButtonGroup>
      <button type="button" @click="handleRouting('previous')">Previous</button>
      <CustomButton type="submit" @click="handleRouting('validateOtp')" :disabled="btnDisable">Validate login code</CustomButton>
      <button type="button" class="resend" @click="handleRouting('resendOtp')" :disabled="btnDisable">Resend login code</button>
    </BaseButtonGroup>
    <MailOtpConfirmationModal  :showMailOtpModalActive="mailOtpActiveModal" @getMailOtpShowStatus="showMailOtpModal" ref="extendedModal"/>

  </div>
</template>


<script>
import BaseButtonGroup from '@/components/ui/BaseButtonGroup';
import * as COMMONS from '../../store/_commons';
import { mapActions } from 'vuex';
import MailOtpConfirmationModal from '../../components/appModal/MailOtpConfirmationModal.vue';
import CustomButton from '../CustomButton.vue';

export default {
  name: 'OTP',
  components: {
    BaseButtonGroup,
    MailOtpConfirmationModal,
    CustomButton
  },
  data() {
    return {
      otp: '',
      count: 0,
      errorMsg: '',
      mailOtpActiveModal: false
    }
  },
  computed: {
    otpEndTime() {
      let dateVal = this.$store.state.guestLogin.loginMfaRequest && this.$store.state.guestLogin.loginMfaRequest.otpEndDateTime;
      let serverDate = new Date(dateVal);
      let offset = new Date(dateVal).getTimezoneOffset()/60;
      let offsetValue = offset == 4 ? -4 : -5
      let utcTime = serverDate.getTime() - (serverDate.getTimezoneOffset()*60000);
      let localDateVal = new Date(utcTime - (3600000 * offsetValue));
      return localDateVal.toLocaleString();
    },
    btnDisable() {
      return this.$store.state.guestLogin.btnDisable;
    },
    contactInfo() {
      return this.$store.state.guestLogin.loginUserDetails;
    }
  },
  created() {
    
  },
  mounted() {
    window.scroll(0,0);
    document.body.setAttribute("tabindex", "1");
    document.body.focus();

    document.body.removeAttribute("tabindex");
    document.getElementById("app").scrollTop = 0;
  },
  methods: {
    ...mapActions({
      getGuestLogin : COMMONS.GUEST_LOGIN_GET_LOGIN,
      getGuestLoginMfaRequest: COMMONS.GUEST_LOGIN_GET_LOGIN_MFA_REQUEST
    }),

    async handleRouting(info) {
      if(info=='previous') {
        if(this.$store.state.guestLogin.loginUserDetails.isPaperOtpSent){
          this.$router.push({name: 'GuestSignin'});
        } else {
          this.$store.state.guestLogin.mfaStep = 1;
          if(this.count >= 3) {
            this.$router.push({name: 'GuestSignin'});
          }
        }
      }
      else if (info=='validateOtp') {
        this.errorMsg='';
        if(this.otp != '' && this.otp != null) {
          this.count = this.count+1;
          let payLoad = {
            verificationCode: this.otp,
            attemptValue: this.count
          }
          await this.getGuestLogin(payLoad);
        }
        else {
          this.errorMsg = 'Login code is required'
        }
      }
      else {
        this.mailOtpActiveModal=true;
      
      } 
    },


  showMailOtpModal(val) {

     if(val=='Yes')
         {
          if(this.contactInfo.email != ''|| this.contactInfo.phone!='') {
          this.$store.state.guestLogin.mfaStep = 1;
        }
        else {
          this.$store.state.guestLogin.mfaStep = 3;
        }
      }
        else
        this.mailOtpActiveModal=false;
    },

  beforeDestroy() {
    this.$store.state.networkResponse = null;
    this.$store.state.guestLogin.btnDisable = false;
  },

}
}
</script>


<style lang="scss" scoped>

.user-otp {
  margin-top: 2rem;
  .input-otp {
    margin-bottom: 3rem;
    .otp-text {
      font-size: 24px;
      margin-bottom: 1rem;
    }
  }
}
.resend {
  background-color: #fff;
  color: var(--ri-blue);
}
.error-msg{
  color: var(--ri-red);
}
</style>